import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import firebase from 'firebase/app'
import IdleVue from 'idle-vue'
import Editor from 'v-markdown-editor'



// import VueSimpleMarkdown from 'vue-simple-markdown'
// import 'vue-simple-markdown/dist/vue-simple-markdown.css'
// Vue.use(VueSimpleMarkdown)
Vue.use(Editor);
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/vuetify'
Vue.config.productionTip = false
let app = ''
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      render: h => h(App)
    }).$mount('#app')
  }
})
const eventsHub = new Vue()
 
Vue.use(IdleVue, {
	eventEmitter: eventsHub,
	store,
	idleTime: 1200000 ,// 20minuter i milliseconds,
	startAtIdle: false
  });
// new Vue({
//   router,
//   store,
//   render: h => h(App),
//   created () {
//      ('Vue Root Instance Created - main.js')
//   }
// }).$mount('#app')
